import styled from "styled-components";

export const CarouselsWrapper = styled.section`
  margin: 0 ${({ theme }) => theme.old.sizes.sidesMargin.large};
  transform: translateY(-135px);

  ${({ theme }) => theme.old.breakpoints.isTab} {
    transform: translateY(-100px);
    margin-left: ${({ theme }) => theme.old.sizes.sidesMargin.small};
    margin-right: 0;
  }

  ${({ theme }) => theme.old.breakpoints.isMobile} {
    transform: translateY(-20px);
  }
`